var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "save-tray-block container my-5",
      attrs: { id: "imageModal", tabindex: "-1", role: "dialog" }
    },
    [
      _c("label", { staticClass: " border-0" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$resourceString["myProject.Project.UploadProjectCover.Title"]
            ) +
            "\n    "
        ),
        _c(
          "div",
          { staticClass: "col-12 font-16 text-muted text-size-normal" },
          [
            _vm._v("\n      " + _vm._s(_vm.description) + "\n      "),
            _c("div", { staticClass: "board-cover-crop" }, [
              _c("div", { staticClass: "nav mb-3 nav-tabs nav-justified" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav nav-item nav-link text-size-normal",
                    class: _vm.getTab === "cover" ? "active" : "",
                    attrs: { href: "", "data-tab": "cover" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleTabClick($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString["myProject.Project.CoverView"]
                      ) + "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "nav nav-item nav-link text-size-normal",
                    class: _vm.getTab === "thumbnail" ? "active" : "",
                    attrs: { href: "", "data-tab": "thumbnail" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleTabClick($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n         " +
                        _vm._s(
                          _vm.$resourceString["myProject.Project.ThumbnailView"]
                        ) +
                        "\n          "
                    )
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tray-cover-undashed" },
          [
            !_vm.getFileUrl
              ? _c(
                  "span",
                  { staticClass: "btn btn-primary call-to-action-button" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$resourceString[
                            "virtualtray.Savetray.UploadImage.Button"
                          ]
                        ) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.getTab === "cover"
              ? _c("pc-project-crop-viewer", {
                  attrs: {
                    src: _vm.getFileUrl,
                    ratio: 4,
                    height: _vm.staticHeight,
                    options: _vm.options
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.getTab === "thumbnail"
              ? _c("pc-project-crop-viewer", {
                  attrs: {
                    src: _vm.getFileUrl,
                    ratio: 360 / 220,
                    height: _vm.staticHeight,
                    options: _vm.options
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-primary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function() {
                _vm.hideModal("project-upload-image")
                _vm.startOverOrCancel(
                  Object.keys(this$1.getUploadImageResp).length === 0
                    ? true
                    : false
                )
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$resourceString["virtualtray.Savetray.Cancel.Button"]
                ) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: {
              type: "button",
              disabled:
                !this.getImageCoverData ||
                !this.getImageThumbnailData ||
                this.imageButtonDisabled
            },
            on: {
              click: function($event) {
                return _vm.handleUploadImage($event)
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$resourceString[
                    "virtualtray.Savetray.Image.Select.Button"
                  ]
                ) +
                "\n    "
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }